import axios from 'axios'
import studentInformation from './studentInformation'
import parentInformation from './parentInformation'
import emergencyContact from './emergencyContact'
import healthConditions from './healthConditions'
import formPartB from './formPartB'
import sibling from './siblings'
import partCInfo from './partCInfo'
import studentReferralQuestionnaire from './studentReferralQuestionnaire'
import azResidencyDocs from './azResidencyDocs'


const state = {}
const mutations = {}
const actions = {
    registerStudent(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/students/registration', payload)
            .then(results => {
                resolve(true)
            })
            .catch(errors => {
                reject(errors)
            })
        })
    }
}

const modules = {
    student: studentInformation,
    parents: parentInformation,
    emergencyContacts: emergencyContact,
    healthConditions: healthConditions,
    formPartB: formPartB,
    siblings: sibling,
    partCInfo: partCInfo,
    studentReferralQuestionnaire: studentReferralQuestionnaire,
    azResidencyDocs: azResidencyDocs,

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules
}
